import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signup from '../views/Signup.vue'
import Login from '../views/Login.vue'
import ForgotPassword from "@/views/Forgotpassword"
import Setup from '../views/Setup.vue'
import Dashboard from '../views/Dashboard.vue'
import Notifications from '@/views/Notifications'
import Newsletters from "@/views/Newsletters"
import Escrow from "@/views/Escrow"
import Subscribers from '@/views/Subscribers'
import Activity from '@/views/Activity'
import Settings from '@/views/Settings'
import Share from '@/views/Share'
import User from "@/views/User"
import Widget from "@/views/Widget"
import Subscribe from "@/views/Subscribe"

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/signup/:id',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/setup-account',
    name: 'Setup',
    component: Setup
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },

  {
    path: '/newsletters',
    name: 'Newsletters',
    component: Newsletters
  },

  {
    path: '/escrow',
    name: 'Escrow',
    component: Escrow
  },

  {
    path:'/notifications',
    name:'Notifications',
    component:Notifications
  },
  {
    path:'/subscribers',
    name:'Subscribers',
    component:Subscribers
  },
  {
    path:'/activity',
    name:'Activity',
    component:Activity
  },
  {
    path:'/settings',
    name:'Settings',
    component:Settings
  },
  {
    path:'/share',
    name:'Share',
    component:Share
  },
  {
    path:'/:id',
    name:'User',
    component:User
  },
  {
    path:'/widget/:id',
    name:'Widget',
    component:Widget
  },
  {
    path:'/subscribe/:id',
    name:'Subscribe',
    component:Subscribe
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
